import { Link } from "react-router-dom";

export default function NotFound() {
  return (
    <div className="relative flex min-h-[60vh] flex-col items-center justify-center px-4 py-20 text-center">
      <span className="flex h-20 w-20 items-center justify-center rounded-full bg-background-100 text-foreground-400">
        <i className="ri-emotion-sad-line text-4xl"></i>
      </span>
      <h1 className="mt-6 font-heading text-3xl font-bold text-foreground-950 md:text-4xl">页面不存在</h1>
      <p className="mt-3 max-w-md text-sm leading-relaxed text-foreground-500">
        你访问的页面可能已被移除或链接地址有误，可以返回首页继续浏览高清视频资源。
      </p>
      <div className="mt-6 flex flex-wrap justify-center gap-3">
        <Link
          to="/"
          className="inline-flex items-center gap-2 whitespace-nowrap rounded-md bg-primary-500 px-5 py-2.5 text-sm font-medium text-background-50 transition-colors hover:bg-primary-600"
        >
          <i className="ri-home-4-line"></i>
          返回首页
        </Link>
        <Link
          to="/search"
          className="inline-flex items-center gap-2 whitespace-nowrap rounded-md border border-background-300 bg-background-50 px-5 py-2.5 text-sm font-medium text-foreground-800 transition-colors hover:border-primary-300 hover:text-primary-600"
        >
          浏览全部视频
        </Link>
      </div>
    </div>
  );
}